interface DistanceProps {
  latA: number
  longA: number
  latB: number
  longB: number
}

const EARTH_RADIUS_IN_MILES = 3958.8

export const getDistanceInMiles = ({ latA, longA, latB, longB }: DistanceProps): number => {
  const degreesToRadians = (deg: number) => {
    return deg * (Math.PI / 180)
  }

  const differenceInLatitude = degreesToRadians(latB - latA)
  const differenceInLongitude = degreesToRadians(longB - longA)

  // Haversine formula
  const haversineLength =
    Math.sin(differenceInLatitude / 2) * Math.sin(differenceInLatitude / 2) +
    Math.cos(degreesToRadians(latA)) *
      Math.cos(degreesToRadians(latB)) *
      Math.sin(differenceInLongitude / 2) *
      Math.sin(differenceInLongitude / 2)

  const angularDistanceInRadians =
    2 * Math.atan2(Math.sqrt(haversineLength), Math.sqrt(1 - haversineLength))

  const distance = EARTH_RADIUS_IN_MILES * angularDistanceInRadians

  return parseFloat(distance.toFixed(1))
}

export const getMilesFromMeters = (meters: number) => {
  return meters * 0.000621371
}
